<template>
  <client-only>
    <div class="contact-us" :class="{ desktop: $isDesktop }">
      <ul class="breadcrumb">
        <li>
          <nuxt-link to="/">
            <translate>Home</translate>
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="$route.fullPath">
            <translate>Contact us</translate>
          </nuxt-link>
        </li>
      </ul>
      <div class="contact-us-main">
        <customer-type
          v-if="contactStore.isCustomerTypeStage && !formSubmited"
        />
        <change-customer-type-link
          v-if="!contactStore.isCustomerTypeStage && !formSubmited"
        />
        <reason-select
          v-if="
            (contactStore.isReasonSelectStage ||
              contactStore.isContactFormStage) &&
            !formSubmited
          "
        />
        <most-popular-questions v-if="contactStore.isContactFormStage" />
        <contact-form
          v-if="contactStore.shouldShowContactForm && !formSubmited"
        />
        <contact-thanks v-if="formSubmited" />
      </div>
      <registered-company-info />
    </div>
    <nuxt-to-meta :nuxt2meta="head" />
  </client-only>
  <script-intercom
    app-id="g82i8k6a"
    class="intercom-button"
    :hide-default-launcher="false"
    @ready="console.log('intercom ready')"
  >
    <div class="intercom-icon-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.4"
        clip-rule="evenodd"
        aria-hidden="true"
        viewBox="1 1 60 60"
      >
        <path
          d="M27.765 42.244c-8.614 0-15.622-7.008-15.622-15.622S19.151 11 27.765 11s15.622 7.008 15.622 15.622-7.007 15.622-15.622 15.622zm0-28.398c-7.045 0-12.775 5.73-12.775 12.775s5.73 12.775 12.775 12.775 12.775-5.73 12.775-12.775-5.73-12.775-12.775-12.775z"
        ></path>
        <path
          d="M34.869 39.146l4.014-3.738 9.286 9.114a3.164 3.164 0 01-.07 4.562l-.071.066a3.163 3.163 0 01-4.561-.257l-8.598-9.747zM27.77 34.173c-2.882 0-5.412-.876-7.656-2.526a1.002 1.002 0 01-.35-.81c.008-.461.445-.969 1.02-.959.284.005.493.153.713.308 1.837 1.302 3.832 1.971 6.275 1.971 1.875 0 4.492-.476 6.314-2.118a.98.98 0 01.638-.261.92.92 0 01.686.241c.222.209.33.527.336.735a1.02 1.02 0 01-.318.775c-1.333 1.237-4.262 2.644-7.658 2.644z"
        ></path>
      </svg>
    </div>
  </script-intercom>
</template>

<script setup lang="ts">
const contactStore = useContactStoreSetup(usePinia())
const formSubmited = computed(() => contactStore.formSubmitted)

const head = computed(() => {
  return {
    title: (useI18n().t('Contact us') as string) + ' | Pitchup.com',
  }
})
</script>

<style scoped>
.contact-us {
  margin: auto;
  max-width: 60em;
  padding: 1em 1.4em 1.4em;
  width: 100%;
}

.breadcrumb {
  margin: 0 0 1em 0;
}

.breadcrumb li {
  display: inline;
  line-height: 1.2;
  vertical-align: top;
  font-size: var(--small);
}

.breadcrumb li a,
.breadcrumb li a:visited {
  font-weight: normal;
  color: #555;
}

.breadcrumb li:after {
  content: '\203A';
  color: #777;
  margin: 0 5px;
}

.breadcrumb li:last-child a {
  pointer-events: none;
  text-decoration: none;
  color: #999;
}

.breadcrumb li:last-child:after {
  content: '';
  margin: 0;
}

.contact-us-main {
  min-height: 50em;
  font-size: var(--body);
}

:deep(.losenge) {
  background: #dcf1ff;
  border-radius: 1em;
  padding: 1em;
  margin: 0 0 1.4em 0;
}

.desktop .contact-us {
  padding: 1em var(--page-width-padding) 1.4em;
}

.intercom-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000;
  max-width: 48px;
  width: 48px;
  max-height: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fd9933;
  cursor: pointer;
  box-shadow:
    0 1px 6px 0 rgba(0, 0, 0, 0.06),
    0 2px 32px 0 rgba(0, 0, 0, 0.16);
  transition: transform 167ms cubic-bezier(0.33, 0, 0, 1);
  box-sizing: content-box;
}

.intercom-icon-container {
  svg,
  path {
    fill: rgb(255, 255, 255);
  }
}
</style>
